/* eslint-disable @typescript-eslint/no-explicit-any */
import { Children } from 'react';
import useAgentData from '~/client/hooks/useAgentData';
import Lazy from './Lazy';

type Props = { height?: number | string };

const LazyLoad: FC<Props> = ({ height, children }) => {
  const { isCrawler } = useAgentData();

  if (isCrawler) {
    return <>{children}</>;
  }

  return (
    <>
      {Children?.map(children, (child: any) => {
        if (!child) {
          return null;
        }
        const { lazyMinHeight = height, gridArea } = child?.props ?? {};
        return (
          <Lazy minHeight={lazyMinHeight} gridArea={gridArea}>
            {child}
          </Lazy>
        );
      })}
    </>
  );
};

export default LazyLoad;
